export enum KestrelInspectionType {
  ROOFTOP = 'rooftop',
  NAVY = 'navy',
}
